import { getCampaignList } from 'api/campaign';
import { useCallback, useEffect, useState } from 'react';
import { ICampaign } from 'types/campaign';

const useGetCampaignList = ():[ICampaign[] | undefined, boolean, string, () => void] => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<ICampaign[]>();
    const [error, setError] = useState('');
    const [fetched, setFetched] = useState(false);

    const fetch = useCallback(async () => {
        setLoading(true);

        try {
            const res = await getCampaignList();

            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                setError(res?.error);
            }
        } catch (e) {
            console.error(e);
        }

        setFetched(true);
        setLoading(false);
    }, []);

    useEffect(() => {
        if (!fetched) {
            fetch();
        }
    }, [fetched]);

    return [data, loading, error, fetch];
};

export default useGetCampaignList;
